import { render, staticRenderFns } from "./InquiryQRCodeScanPop.vue?vue&type=template&id=fed34f7c&scoped=true&"
import script from "./InquiryQRCodeScanPop.vue?vue&type=script&lang=js&"
export * from "./InquiryQRCodeScanPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed34f7c",
  null
  
)

component.options.__file = "InquiryQRCodeScanPop.vue"
export default component.exports